<template>
  <div class="u-h3">
    {{ globals.share }}
    <a class="e-link--secondary u-h2" @click.prevent="windowPopup(`https://www.facebook.com/sharer/sharer.php?u=${href}`, 500, 300)" href="#">Facebook</a> {{ globals.or }}
    <a class="e-link--secondary u-h2" @click.prevent="windowPopup(`https://twitter.com/intent/tweet/?text=${globals.title}&url=${href}`, 500, 300)" href="#">Twitter</a>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'SocialShare',

  data () {
    return {
      href: ''
    }
  },

  mounted () {
    this.href = window.location.href
  },

  methods: {
    windowPopup (url, width, height) {
      const left = (screen.width / 2) - (width / 2)
      const top = (screen.height / 2) - (height / 2)

      window.open(
        url,
        '',
        'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=' + width + ',height=' + height + ',top=' + top + ',left=' + left
      )
    }
  },

  computed: mapState({
    lang: state => state.language,
    globals (state) {
      const lang = this.lang
      return state.translations.general[lang]
    }
  })
}
</script>
